'use client';

/* สไลด์ค่าย/สไลด์เกมบนหน้าแรกเป็น HTML ฝั่ง server (ไว้ให้ crawler อ่าน) — ตัวนี้แค่ดักคลิก
   ตรงกับของจริงในหลังบ้าน = เข้าเกม/ค่ายนั้นตรง ๆ · ไม่ตรง = ทางเข้าตรง usun
   ยังไม่ล็อกอิน = ให้ปุ่มเข้าสู่ระบบเดิมเปิดกล่องให้ (ปล่อย href="/reviews" ไว้เป็นทางลงเมื่อไม่มี JS) */

import { useEffect } from 'react';
import { requestGame } from '../lib/gameNavigation';
import toast from '../lib/toast';
import { getToken, launchGame } from '../lib/auth';
import { resolveTarget } from '../lib/launcher';

export default function HomeLaunch() {
  useEffect(() => {
    const onClick = async (e) => {
      const a = e.target.closest('a[data-game], a[data-prov]');
      if (e.target.closest('.camp-demo')) return;   // ปุ่มทดลองเล่นฟรี = ไปหน้ารวมเกมเดโมของเว็บ
      if (!a || e.metaKey || e.ctrlKey || e.button > 0) return;
      e.preventDefault();

      if (!getToken()) {
        document.querySelector('[data-auth]:not([data-auth="register"])')?.click();
        return;
      }
      if (a.dataset.busy) return;
      a.dataset.busy = '1';
      try { await requestGame(async (signal) => {
        // การ์ดเกมที่ sync มาจากหลังบ้านมีรหัสเกมติดมาแล้ว ไม่ต้องจับคู่ชื่อ
        const t = a.dataset.code
          ? { gameName: a.dataset.prov, gameCode: a.dataset.code }
          : await resolveTarget({ game: a.dataset.game, provider: a.dataset.prov, hint: a.dataset.hint });
        const url = await launchGame(t.gameName, t.gameCode ? { gameCode: t.gameCode } : {}, signal);
      return url;
    }); } finally { delete a.dataset.busy; }
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);
  return null;
}
